import type { SVGProps } from 'react';

const SvgAspectRatio = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 4H6C4.35 4 3 5.35 3 7v10c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3V7c0-1.65-1.35-3-3-3m1 13c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1h12c.55 0 1 .45 1 1z"
    />
    <path
      fill="currentcolor"
      d="M11 8H9c-1.1 0-2 .9-2 2v2c0 .55.45 1 1 1s1-.45 1-1v-2h2c.55 0 1-.45 1-1s-.45-1-1-1m5 3c-.55 0-1 .45-1 1v2h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c1.1 0 2-.9 2-2v-2c0-.55-.45-1-1-1"
    />
  </svg>
);
export default SvgAspectRatio;
